// extracted by mini-css-extract-plugin
export var chevronIcon = "_de-2";
export var teamName = "_de-1";
export var teamSwitcherButton = "_de-0";